import { View, StyleSheet, Text } from '@react-pdf/renderer';

interface PdfApplicantCertificationProps {
  data: any;
}

export const PdfApplicantCertification: React.FC<PdfApplicantCertificationProps> = () => {
  const styles = StyleSheet.create({
    text: {
      fontSize: '6.4px'
    },
    leftColumn: {
      flexDirection: 'row'
    },
    row: {
      width: '100%'
    },
    image: {
      width: '60%'
    },
    box: {
      width: '100%',
      border: '1px solid black',
      padding: 5,
      marginTop: 10
    },
    divider: {
      width: '45%',
      height: '1px',
      border: 0,
      borderTop: '0.75px solid black',
      padding: 0,
      color: '#00FFFF',
      marginRight: 10,
      marginTop: 5
    }
  });

  return (
    <View style={styles.box}>
        <View style={[styles.text, { flexDirection: 'row', justifyContent: 'flex-start', flexWrap: 'wrap', alignItems: 'center', paddingBottom: 10}]}>
          <Text style={{fontFamily: 'Libre Franklin Bold'}}>
            APPLICANT RELEASE OF INFORMATION AND ATTESTATION
          </Text>
          <Text style={{fontFamily: 'Libre Franklin'}}>{' '}(To be completed by health professional)</Text>
        </View>

      <Text style={[styles.text, { paddingBottom: 10, fontFamily: 'Libre Franklin Bold' }]}>
        Release of Information Authorization
      </Text>
      <Text style={[styles.text, { paddingBottom: 10 }]}>
        I request and authorize every person, credential-issuing institution, university, hospital, government agency, or other entity
        to release information to Intealth bearing on the content of my request or any document submitted to Intealth,
        including, but not limited to: records, diplomas, transcripts, and other documents concerning my identity,
        citizenship or immigration status, educational, academic or professional history and status, or enrollment.
      </Text>
      <Text style={[styles.text, { paddingBottom: 10 }]}>
        I hereby request and authorize Intealth to transmit any documents or information in its possession, or that may otherwise become available
        to Intealth, bearing on the content of my application or any other request related to services I have asked Intealth to provide me, including, but not
        limited to: records, diplomas, transcripts, licenses/registrations and other documents concerning my identity, citizenship or
        immigration status, educational, academic or professional history and status, enrollment, where such disclosure is necessary for Intealth to provide the requested services,
        and/or to any other organization or individual who, in the sole judgement of Intealth has a legitimate interest in such information, including but not limited to:
        any federal, state, or local governmental department or agency; U.S. state and international licensing authorities; and education programs.
      </Text>
      <Text style={[styles.text, { paddingBottom: 10 }]}>
        I also extend absolute immunity to, and release, other agencies, credential-issuing institution, universities, institutions,
        hospitals and clinics, and registration and licensing authorities providing information, their employees,
        representatives, directors, and officers, and any third parties and organizations for their acts,
        communications, reports, records, diplomas, transcripts, statements, documents, recommendations, or disclosures
        involving me, made in good faith and without malice, requested by Intealth.
      </Text>
      <Text style={{ paddingBottom: 10, fontSize: "7.4px" }}>
        I HAVE READ, UNDERSTOOD AND AGREE TO THIS RELEASE OF INFORMATION AUTHORIZATION AND I INTEND TO BE LEGALLY BOUND
        BY IT.
      </Text>
      <Text style={[styles.text, { fontFamily: "Libre Franklin Bold" }]}>Attestation</Text>
      <Text style={[styles.text, { paddingBottom: 10 }]}>
        I certify that I am the individual named above, am represented in the attached photograph, the attached passport
        is a copy of the passport that was issued to me, and that the signature below is my signature.
      </Text>
      {/* React-pdf does not support changing fonts within nested Text components. To work around this, we use flex and wrapping to recreate each line separately. */}     
      <View style={[styles.text, { flexDirection: 'row', justifyContent: 'flex-start', flexWrap: 'wrap', paddingBottom: 10 }]}>
        <Text style={{fontFamily: "Libre Franklin"}}>I hereby certify that I have read, understood, and agree to all of the above statements. I also certify that I have read the </Text>
        <Text style={{fontFamily: "Libre Franklin Italic"}}>Policies and Procedures Regarding</Text>
        <Text style={{fontFamily: "Libre Franklin Italic"}}>Irregular Behavior</Text>
        <Text style={{fontFamily: "Libre Franklin"}}> and agree to abide by these policies and procedures. I certify I understand that, as provided in the </Text>
        <Text style={{fontFamily: "Libre Franklin Italic"}}>Policies and Procedures Regarding</Text>
        <Text style={{fontFamily: "Libre Franklin Italic"}}>Irregular Behavior</Text>
        <Text style={{fontFamily: "Libre Franklin"}}>, among other things, Intealth may find that submission of falsified documents to Intealth constitutes irregular behavior, which could result in</Text>
        <Text style={{fontFamily: "Libre Franklin"}}>actions including permanent revocation of or permanent bar to ECFMG Certification, among other things.</Text> 
        
      </View>
      <View style={styles.leftColumn}>
        <Text style={styles.text}>X</Text>
        <Text style={styles.divider}></Text>
        <Text style={styles.divider}></Text>
      </View>
      <View style={styles.leftColumn}>
        <Text style={[styles.text, { marginRight: 130, marginLeft: 8 }]}>Signature of Applicant</Text>
        <Text style={[styles.text, {marginLeft: 25}]}>Date</Text>
      </View>
    </View>
  );
};
export default PdfApplicantCertification;
